import siteConfig from "./runtime-config.js";
const mcConfig = siteConfig["brand-config"][0].brand;
const crestConfig = siteConfig["brand-config"][1].brand;
/**
 * 
 */
export const config = {
    mastercraft: {
        brandLogo: mcConfig.brandLogo,
        brandName: mcConfig.brandName,
        brandUrl: mcConfig.brandLink,
        footerLogo: mcConfig.footerLogo,
        copyright: new Date().getFullYear() + " MasterCraft. All rights reserved.",
        nationalSearchGUID: mcConfig.nationalSearchGUID,
        socialMedia: [
            {
                // Links - Facebook
                icon: mcConfig.links.social_media.facebook.icon,
                label: mcConfig.links.social_media.facebook.name,
                url: mcConfig.links.social_media.facebook.link,
                target: mcConfig.links.social_media.facebook.target,
                isActive: mcConfig.links.social_media.facebook.isActive,
                showForNational: mcConfig.links.social_media.facebook.showForNational
            },
            {
                // Links - Instagram
                icon: mcConfig.links.social_media.instagram.icon,
                label: mcConfig.links.social_media.instagram.name,
                url: mcConfig.links.social_media.instagram.link,
                target: mcConfig.links.social_media.instagram.target,
                isActive: mcConfig.links.social_media.instagram.isActive,
                showForNational: mcConfig.links.social_media.instagram.showForNational
            },
            {
                // Links - Twitter (X)
                icon: mcConfig.links.social_media.x_twitter.icon,
                label: mcConfig.links.social_media.x_twitter.name,
                url: mcConfig.links.social_media.x_twitter.link,
                target: mcConfig.links.social_media.x_twitter.target,
                isActive: mcConfig.links.social_media.x_twitter.isActive,
                showForNational: mcConfig.links.social_media.x_twitter.showForNational
            },
            {
                // Links - YouTube
                icon: mcConfig.links.social_media.youtube.icon,
                label: mcConfig.links.social_media.youtube.name,
                url: mcConfig.links.social_media.youtube.link,
                target: mcConfig.links.social_media.youtube.target,
                isActive: mcConfig.links.social_media.youtube.isActive,
                showForNational: mcConfig.links.social_media.youtube.showForNational
            },
            {
                // Links - LinkedIn
                icon: mcConfig.links.social_media.linkedin.icon,
                label: mcConfig.links.social_media.linkedin.name,
                url: mcConfig.links.social_media.linkedin.link,
                target: mcConfig.links.social_media.linkedin.target,
                isActive: mcConfig.links.social_media.linkedin.isActive,
                showForNational: mcConfig.links.social_media.linkedin.showForNational
            }
        ],

        header: [
            {
                // Links - Inventory
                name: mcConfig.links.sales.inventory.name,
                link: mcConfig.links.sales.inventory.link,
                target: mcConfig.links.sales.inventory.target,
                isActive: mcConfig.links.sales.inventory.isActive,
                dropdown: mcConfig.links.sales.inventory.dropdown,
                showForNational: mcConfig.links.sales.inventory.showForNational,
                smallMenu: false
            },
            {
                // Links - Design a Boat
                name: mcConfig.links.sales.design_a_boat.name,
                link: mcConfig.links.sales.design_a_boat.link,
                target: mcConfig.links.sales.design_a_boat.target,
                isActive: mcConfig.links.sales.design_a_boat.isActive,
                dropdown: mcConfig.links.sales.design_a_boat.dropdown,
                showForNational: mcConfig.links.sales.design_a_boat.showForNational,
                smallMenu: false
            },
            {
                // Links - Trade-In
                name: mcConfig.links.sales.trade_in.name,
                link: mcConfig.links.sales.trade_in.link,
                target: mcConfig.links.sales.trade_in.target,
                isActive: mcConfig.links.sales.trade_in.isActive,
                dropdown: mcConfig.links.sales.trade_in.dropdown,
                showForNational: mcConfig.links.sales.trade_in.showForNational,
                smallMenu: false
            },
            {
                // Links - Parts & Service
                name: 'Parts & Service',
                link: 'javascript:void(0)',
                target: '_self',
                isActive: true,
                showForNational: false,
                dropdown: true,
                dropdownLinks: [
                    { name: 'MasterCraft', link: '/Contact/PartsService', dropdown: false },
                    { name: 'Ilmor', link: 'https://www.ilmor.com/results/1/inboard-stern-drive', target: "_blank", dropdown: false },
                ],
                smallMenu: false,
            },
            {
                // Links - Apparel
                name: mcConfig.links.company.apparel.name,
                link: mcConfig.links.company.apparel.link,
                target: mcConfig.links.company.apparel.target,
                isActive: mcConfig.links.company.apparel.isActive,
                dropdown: mcConfig.links.company.apparel.dropdown,
                showForNational: mcConfig.links.company.apparel.showForNational,
                smallMenu: false,
            },
            {
                // Links - Request Brochure
                name: mcConfig.links.company.request_brochure.name,
                link: mcConfig.links.company.request_brochure.link,
                target: mcConfig.links.company.request_brochure.target,
                isActive: mcConfig.links.company.request_brochure.isActive,
                dropdown: mcConfig.links.company.request_brochure.dropdown,
                showForNational: mcConfig.links.company.request_brochure.showForNational,
                smallMenu: true,
            },
            {
                // Links - Contact Us
                name: mcConfig.links.company.contact_us.name,
                link: mcConfig.links.company.contact_us.link,
                target: mcConfig.links.company.contact_us.target,
                isActive: mcConfig.links.company.contact_us.isActive,
                dropdown: mcConfig.links.company.contact_us.dropdown,
                showForNational: mcConfig.links.company.contact_us.showForNational,
                smallMenu: true,
            },
        ],

        utility: [
            {
                // Links - Contact Us
                name: mcConfig.links.company.contact_us.name,
                link: mcConfig.links.company.contact_us.link,
                target: mcConfig.links.company.contact_us.target,
                isActive: mcConfig.links.company.contact_us.isActive,
                dropdown: mcConfig.links.company.contact_us.dropdown,
                showForNational: mcConfig.links.company.contact_us.showForNational,
                smallMenu: true,
                class: 'button-contact',
            },
            {
                // Links - Design a Boat
                name: mcConfig.links.sales.design_a_boat.name,
                link: mcConfig.links.sales.design_a_boat.link,
                target: mcConfig.links.sales.design_a_boat.target,
                isActive: mcConfig.links.sales.design_a_boat.isActive,
                dropdown: mcConfig.links.sales.design_a_boat.dropdown,
                showForNational: mcConfig.links.sales.design_a_boat.showForNational,
                smallMenu: false,
                class: 'button-dab',
            },
        ],

        footer: [
            {
                title: 'OUR SERVICES',
                menubar: [
                    {
                        // Links - Inventory
                        name: mcConfig.links.sales.inventory.name,
                        link: mcConfig.links.sales.inventory.link,
                        target: mcConfig.links.sales.inventory.target,
                        isActive: mcConfig.links.sales.inventory.isActive,
                        dropdown: mcConfig.links.sales.inventory.dropdown,
                        showForNational: mcConfig.links.sales.inventory.showForNational,
                    },
                    {
                        // Links - Design a Boat
                        name: mcConfig.links.sales.design_a_boat.name,
                        link: mcConfig.links.sales.design_a_boat.link,
                        target: mcConfig.links.sales.design_a_boat.target,
                        isActive: mcConfig.links.sales.design_a_boat.isActive,
                        dropdown: mcConfig.links.sales.design_a_boat.dropdown,
                        showForNational: mcConfig.links.sales.design_a_boat.showForNational
                    },
                    {
                        // Links - Trade-In
                        name: mcConfig.links.sales.trade_in.name,
                        link: mcConfig.links.sales.trade_in.link,
                        target: mcConfig.links.sales.trade_in.target,
                        isActive: mcConfig.links.sales.trade_in.isActive,
                        dropdown: mcConfig.links.sales.trade_in.dropdown,
                        showForNational: mcConfig.links.sales.trade_in.showForNational
                    },
                    {
                        // Links - Parts & Service
                        name: mcConfig.links.sales.parts_and_service.name,
                        link: mcConfig.links.sales.parts_and_service.link,
                        target: mcConfig.links.sales.parts_and_service.target,
                        isActive: mcConfig.links.sales.parts_and_service.isActive,
                        dropdown: mcConfig.links.sales.parts_and_service.dropdown,
                        showForNational: mcConfig.links.sales.parts_and_service.showForNational
                    },
                ]
            },
            {
                title: 'COMPANY',
                menubar: [
                    {
                        // Links - Request Brochure
                        name: mcConfig.links.company.request_brochure.name,
                        link: mcConfig.links.company.request_brochure.link,
                        target: mcConfig.links.company.request_brochure.target,
                        isActive: mcConfig.links.company.request_brochure.isActive,
                        dropdown: mcConfig.links.company.request_brochure.dropdown,
                        showForNational: mcConfig.links.company.request_brochure.showForNational,
                    },
                    {
                        // Links - Contact Us
                        name: mcConfig.links.company.contact_us.name,
                        link: mcConfig.links.company.contact_us.link,
                        target: mcConfig.links.company.contact_us.target,
                        isActive: mcConfig.links.company.contact_us.isActive,
                        dropdown: mcConfig.links.company.contact_us.dropdown,
                        showForNational: mcConfig.links.company.contact_us.showForNational
                    },
                    {
                        // Links - Design a Boat
                        name: mcConfig.links.sales.design_a_boat.name,
                        link: mcConfig.links.sales.design_a_boat.link,
                        target: mcConfig.links.sales.design_a_boat.target,
                        isActive: mcConfig.links.sales.design_a_boat.isActive,
                        dropdown: mcConfig.links.sales.design_a_boat.dropdown,
                        showForNational: mcConfig.links.sales.design_a_boat.showForNational
                    },
                ]
            },
            {
                title: 'LEGAL',
                menubar: [
                    {
                        // Links - Terms & Conditions
                        name: mcConfig.links.legal.terms_and_conditions.name,
                        link: mcConfig.links.legal.terms_and_conditions.link,
                        target: mcConfig.links.legal.terms_and_conditions.target,
                        isActive: mcConfig.links.legal.terms_and_conditions.isActive,
                        dropdown: mcConfig.links.legal.terms_and_conditions.dropdown,
                        showForNational: mcConfig.links.legal.terms_and_conditions.showForNational
                    },
                    {
                        // Links - Privacy Policy
                        name: mcConfig.links.legal.privacy_policy.name,
                        link: mcConfig.links.legal.privacy_policy.link,
                        target: mcConfig.links.legal.privacy_policy.target,
                        isActive: mcConfig.links.legal.privacy_policy.isActive,
                        dropdown: mcConfig.links.legal.privacy_policy.dropdown,
                        showForNational: mcConfig.links.legal.privacy_policy.showForNational
                    },
                    {
                        // Links - Accessibility
                        name: mcConfig.links.legal.accessibility.name,
                        link: mcConfig.links.legal.accessibility.link,
                        target: mcConfig.links.legal.accessibility.target,
                        isActive: mcConfig.links.legal.accessibility.isActive,
                        dropdown: mcConfig.links.legal.accessibility.dropdown,
                        showForNational: mcConfig.links.legal.accessibility.showForNational
                    },
                    {
                        // Links - Cookie Settings
                        name: mcConfig.links.legal.cookie_settings.name,
                        link: mcConfig.links.legal.cookie_settings.link,
                        target: mcConfig.links.legal.cookie_settings.target,
                        isActive: mcConfig.links.legal.cookie_settings.isActive,
                        dropdown: mcConfig.links.legal.cookie_settings.dropdown,
                        showForNational: mcConfig.links.legal.cookie_settings.showForNational
                    },

                ]


            }
        ],
        //termCondition: [
        //    {
        //        label: 'Terms & Conditions',
        //        url: 'https://www.mastercraft.com/terms-and-conditions',
        //        target: 'self',
        //        isActive: true
        //    },
        //    {
        //        label: 'Privacy Policy',
        //        url: 'https://www.mastercraft.com/privacy-statement',
        //        target: 'self',
        //        isActive: true
        //    },
        //    {
        //        label: 'Accessibility',
        //        url: 'https://www.mastercraft.com/website-accessibility-statement',
        //        target: 'self',
        //        isActive: true
        //    },
        //     {
        //         label: 'Cookie Settings',
        //         url: 'javascript:showCookieBanner();',
        //         target: 'self',
        //         isActive: true
        //     },

        //],
        models: [
            {
                value: 'NXT20',
                label: 'NXT20'
            },
            {
                value: 'NXT22',
                label: 'NXT22'
            },
            {
                value: 'NXT24',
                label: 'NXT24'
            },
            {
                value: 'XT20',
                label: 'XT20'
            },
            {
                value: 'XT21',
                label: 'XT21'
            },
            {
                value: 'XT22',
                label: 'XT22'
            },
            {
                value: 'XT23',
                label: 'XT23'
            },
            {
                value: 'XT24',
                label: 'XT24'
            },
            {
                value: 'XT25',
                label: 'XT25'
            },
            {
                value: 'X22',
                label: 'X22'
            },
            {
                value: 'X24',
                label: 'X24'
            },
            {
                value: 'X26',
                label: 'X26'
            },
            {
                value: 'XSTAR',
                label: 'XSTAR'
            },
            {
                value: 'XSTAR S',
                label: 'XSTAR S'
            },
            {
                value: 'PROSTAR',
                label: 'PROSTAR'
            }
        ]
    },

    crest: {
        // Main
        brandName: crestConfig.brandName,
        brandLogo: crestConfig.brandLogo,
        brandUrl: crestConfig.brandLink,
        footerLogo: crestConfig.footerLogo,
        copyright: new Date().getFullYear() + " Crest. All rights reserved.",
        nationalSearchGUID: crestConfig.nationalSearchGUID,
        // Social Media
        socialMedia: [{
            // Facebook
            icon: crestConfig.links.social_media.facebook.icon,
            label: crestConfig.links.social_media.facebook.name,
            url: crestConfig.links.social_media.facebook.link,
            target: crestConfig.links.social_media.facebook.target,
            isActive: crestConfig.links.social_media.facebook.isActive,
            showForNational: crestConfig.links.social_media.facebook.showForNational,
        },
        {
            // Instagram
            icon: crestConfig.links.social_media.instagram.icon,
            label: crestConfig.links.social_media.instagram.name,
            url: crestConfig.links.social_media.instagram.link,
            target: crestConfig.links.social_media.instagram.target,
            isActive: crestConfig.links.social_media.instagram.isActive,
            showForNational: crestConfig.links.social_media.instagram.showForNational,
        },
        {
            // Youtube
            icon: crestConfig.links.social_media.youtube.icon,
            label: crestConfig.links.social_media.youtube.name,
            url: crestConfig.links.social_media.youtube.link,
            target: crestConfig.links.social_media.youtube.target,
            isActive: crestConfig.links.social_media.youtube.isActive,
            showForNational: crestConfig.links.social_media.youtube.showForNational,
        }
        ],
        // Header Links
        header: [
            {
                // Inventory
                name: crestConfig.links.sales.inventory.name,
                link: crestConfig.links.sales.inventory.link,
                target: crestConfig.links.sales.inventory.target,
                isActive: crestConfig.links.sales.inventory.isActive,
                dropdown: crestConfig.links.sales.inventory.dropdown,
                showForNational: crestConfig.links.sales.inventory.showForNational,
            },
            {
                // Design a Boat
                name: crestConfig.links.sales.design_a_boat.name,
                link: crestConfig.links.sales.design_a_boat.link,
                target: crestConfig.links.sales.design_a_boat.target,
                isActive: crestConfig.links.sales.design_a_boat.isActive,
                dropdown: crestConfig.links.sales.design_a_boat.dropdown,
                showForNational: crestConfig.links.sales.design_a_boat.showForNational
            },
            {
                // Trade-In
                name: crestConfig.links.sales.trader_in.name,
                link: crestConfig.links.sales.trader_in.link,
                target: crestConfig.links.sales.trader_in.target,
                isActive: crestConfig.links.sales.trader_in.isActive,
                dropdown: crestConfig.links.sales.trader_in.dropdown,
                showForNational: crestConfig.links.sales.trader_in.showForNational
            },
            {
                // Parts & Service
                name: crestConfig.links.sales.parts_and_service.name,
                link: crestConfig.links.sales.parts_and_service.link,
                target: crestConfig.links.sales.parts_and_service.target,
                isActive: crestConfig.links.sales.parts_and_service.isActive,
                dropdown: crestConfig.links.sales.parts_and_service.dropdown,
                showForNational: crestConfig.links.sales.parts_and_service.showForNational
            },
            {
                // Apparel
                name: crestConfig.links.company.apparel.name,
                link: crestConfig.links.company.apparel.link,
                target: crestConfig.links.company.apparel.target,
                isActive: crestConfig.links.company.apparel.isActive,
                dropdown: crestConfig.links.company.apparel.dropdown,
                showForNational: crestConfig.links.company.apparel.showForNational,
            },
            {
                // Request Brochure
                name: crestConfig.links.company.request_brochure.name,
                link: crestConfig.links.company.request_brochure.link,
                target: crestConfig.links.company.request_brochure.target,
                isActive: crestConfig.links.company.request_brochure.isActive,
                dropdown: crestConfig.links.company.request_brochure.dropdown,
                showForNational: crestConfig.links.company.request_brochure.showForNational,
            },
            //{
            //    name: 'News & Events',
            //    link: '/newsevents',
            //    target: 'self',
            //    isActive: true,
            //    dropdown: false,
            //},
            {
                // Contact Us
                name: crestConfig.links.company.contact_us.name,
                link: crestConfig.links.company.contact_us.link,
                target: crestConfig.links.company.contact_us.target,
                isActive: crestConfig.links.company.contact_us.isActive,
                dropdown: crestConfig.links.company.contact_us.dropdown,
            }
        ],
        // Utility Links
        utility: [
            {
                // Contact Us
                name: crestConfig.links.company.contact_us.name,
                link: crestConfig.links.company.contact_us.link,
                target: crestConfig.links.company.contact_us.target,
                isActive: crestConfig.links.company.contact_us.isActive,
                dropdown: crestConfig.links.company.contact_us.dropdown,
                smallMenu: true,
                class: 'button-contact',
            },
            {
                // Design a Boat
                name: crestConfig.links.sales.design_a_boat.name,
                link: crestConfig.links.sales.design_a_boat.link,
                target: crestConfig.links.sales.design_a_boat.target,
                isActive: crestConfig.links.sales.design_a_boat.isActive,
                dropdown: crestConfig.links.sales.design_a_boat.dropdown,
                showForNational: crestConfig.links.sales.design_a_boat.showForNational,
                smallMenu: false,
                class: 'button-dab',
            },
        ],
        // Footer Links
        footer: [{
            title: 'Sales/Service',
            menubar: [{
                // Inventory
                name: crestConfig.links.sales.inventory.name,
                link: crestConfig.links.sales.inventory.link,
                target: crestConfig.links.sales.inventory.target,
                isActive: crestConfig.links.sales.inventory.isActive,
                dropdown: crestConfig.links.sales.inventory.dropdown,
                showForNational: crestConfig.links.sales.inventory.showForNational,

            }, {
                // Design a Boat
                name: crestConfig.links.sales.design_a_boat.name,
                link: crestConfig.links.sales.design_a_boat.link,
                target: crestConfig.links.sales.design_a_boat.target,
                isActive: crestConfig.links.sales.design_a_boat.isActive,
                dropdown: crestConfig.links.sales.design_a_boat.dropdown,
                showForNational: crestConfig.links.sales.design_a_boat.showForNational
            }, {
            }, {
                // Trade In
                name: crestConfig.links.sales.trader_in.name,
                link: crestConfig.links.sales.trader_in.link,
                target: crestConfig.links.sales.trader_in.target,
                isActive: crestConfig.links.sales.trader_in.isActive,
                dropdown: crestConfig.links.sales.trader_in.dropdown,
            },
            {
                // Parts & Service
                name: crestConfig.links.sales.parts_and_service.name,
                link: crestConfig.links.sales.parts_and_service.link,
                target: crestConfig.links.sales.parts_and_service.target,
                isActive: crestConfig.links.sales.parts_and_service.isActive,
                dropdown: crestConfig.links.sales.parts_and_service.dropdown,
            }
            ]
        },
        {
            title: 'Company',
            menubar: [{
                // Request Brochure
                name: crestConfig.links.company.request_brochure.name,
                link: crestConfig.links.company.request_brochure.link,
                target: crestConfig.links.company.request_brochure.target,
                isActive: crestConfig.links.company.request_brochure.isActive,
                dropdown: crestConfig.links.company.request_brochure.dropdown,
            },
            {
                // Contact Us
                name: crestConfig.links.company.contact_us.name,
                link: crestConfig.links.company.contact_us.link,
                target: crestConfig.links.company.contact_us.target,
                isActive: crestConfig.links.company.contact_us.isActive,
                dropdown: crestConfig.links.company.contact_us.dropdown,
            }, {
                // Apparel
                name: crestConfig.links.company.apparel.name,
                link: crestConfig.links.company.apparel.link,
                target: crestConfig.links.company.apparel.target,
                isActive: crestConfig.links.company.apparel.isActive,
                dropdown: crestConfig.links.company.apparel.dropdown,
                showForNational: crestConfig.links.company.apparel.showForNational,
            }
            ]
        },
        {
            title: 'Legal',
            menubar: [{
                // Terms & Conditions
                name: crestConfig.links.legal.terms_and_conditions.name,
                link: crestConfig.links.legal.terms_and_conditions.link,
                target: crestConfig.links.legal.terms_and_conditions.target,
                isActive: crestConfig.links.legal.terms_and_conditions.isActive,
                dropdown: crestConfig.links.legal.terms_and_conditions.dropdown,
                showForNational: crestConfig.links.legal.terms_and_conditions.showForNational,
            },
            {
                // Privacy Policy
                name: crestConfig.links.legal.privacy_policy.name,
                link: crestConfig.links.legal.privacy_policy.link,
                target: crestConfig.links.legal.privacy_policy.target,
                isActive: crestConfig.links.legal.privacy_policy.isActive,
                dropdown: crestConfig.links.legal.privacy_policy.dropdown,
                showForNational: crestConfig.links.legal.privacy_policy.showForNational,
            },
            {
                // Accessibility
                name: crestConfig.links.legal.accessibility.name,
                link: crestConfig.links.legal.accessibility.link,
                target: crestConfig.links.legal.accessibility.target,
                isActive: crestConfig.links.legal.accessibility.isActive,
                dropdown: crestConfig.links.legal.accessibility.dropdown,
                showForNational: crestConfig.links.legal.accessibility.showForNational,
            }, {
                // Cookie Settings
                name: crestConfig.links.legal.cookie_settings.name,
                link: crestConfig.links.legal.cookie_settings.link,
                target: crestConfig.links.legal.cookie_settings.target,
                isActive: crestConfig.links.legal.cookie_settings.isActive,
                dropdown: crestConfig.links.legal.cookie_settings.dropdown,
                showForNational: crestConfig.links.legal.cookie_settings.showForNational,
            }
            ]
        },


        ],
        //termCondition: [{
        //        label: 'Terms & Conditions',
        //        url: 'https://crestpontoonboats.com/terms-and-conditions',
        //        target: 'self',
        //        isActive: true
        //    },
        //    {
        //        label: 'Privacy Policy',
        //        url: 'https://crestpontoonboats.com/privacy-statement',
        //        target: 'self',
        //        isActive: true
        //    },
        //    // {
        //        // label: 'Cookie Settings',
        //        // url: 'javascript:showCookieBanner();',
        //        // target: 'self',
        //        // isActive: true
        //    // },
        //    {
        //        label: 'Accessibility',
        //        url: 'https://crestpontoonboats.com/website-accessibility-statement',
        //        target: 'self',
        //        isActive: true
        //    }
        //],

        // Models
        models: [{
            value: 'Caribbean LX',
            label: 'Caribbean LX'
        },
        {
            value: 'Caribbean RS',
            label: 'Caribbean RS'
        },
        {
            value: 'Caribbean Platinum',
            label: 'Caribbean Platinum'
        },
        {
            value: 'Classic LX',
            label: 'Classic LX'
        },
        {
            value: 'Classic DLX',
            label: 'Classic DLX'
        },
        {
            value: 'Classic Platinum',
            label: 'Classic Platinum'
        },
        {
            value: 'Continental',
            label: 'Continental'
        },
        {
            value: 'Continental NX',
            label: 'Continental NX'
        },
        {
            value: 'Savannah',
            label: 'Savannah'
        },
        {
            value: 'Not Sure',
            label: 'Not Sure'
        }
        ]
    },

}
/**
 * 
 * @param {*} brand 
 * @param {*} key 
 * @returns 
 */
export const getBrandDetails = (brand, key) => config[brand][key];
/**
 * 
 */
export default getBrandDetails;